export default "__VITE_ASSET__Hi7DSZkh__"